import { Expose } from "class-transformer";
import { Model } from "../../../shared/models/model";

export class TrucksCounts extends Model {
    @Expose() totalFreelanceTrucksCount: number;
    @Expose() totalFleetsTrucksCount: number;
}
